import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearLiquidationDifferenceReasons,
  getLiquidationDifferenceReasons,
} from '../../../../actions/accounting/LiquidationDifferenceReason';
import { LIQUIDATION_DIFFERENCE_REASON_PATH, NEW_LIQUIDATION_DIFFERENCE_REASON_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { LIQUIDATION_DIFFERENCE_REASON_COLUMNS } from '../../../../config/columns';

export const LiquidationDifferenceReason = ({
  breadcrumbs,
  liquidationDifferenceReasons,
  loading,
  dispatchGetLiquidationDifferenceReason,
  dispatchClearLiquidationDifferenceReason,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearLiquidationDifferenceReason();
    },
    [],
  );

  const data = liquidationDifferenceReasons.get('content') || [];
  const pages = liquidationDifferenceReasons.get('totalPages') || null;
  const defaultPageSize = liquidationDifferenceReasons.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Discrepancias de Liquidación"
      buttonPath={NEW_LIQUIDATION_DIFFERENCE_REASON_PATH}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: LIQUIDATION_DIFFERENCE_REASON_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetLiquidationDifferenceReason,
        loading,
        modelPath: LIQUIDATION_DIFFERENCE_REASON_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetLiquidationDifferenceReason: getLiquidationDifferenceReasons,
  dispatchClearLiquidationDifferenceReason: clearLiquidationDifferenceReasons,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Discrepancias de Liquidación',
      href: LIQUIDATION_DIFFERENCE_REASON_PATH,
    },
  ],
  liquidationDifferenceReasons: AccountingUnit.LiquidationDifferenceReason.getIn(['all', 'content']),
  loading: AccountingUnit.LiquidationDifferenceReason.getIn(['all', 'loading']),
});

LiquidationDifferenceReason.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  liquidationDifferenceReasons: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetLiquidationDifferenceReason: PropTypes.func.isRequired,
  dispatchClearLiquidationDifferenceReason: PropTypes.func.isRequired,
};

LiquidationDifferenceReason.defaultProps = {
  liquidationDifferenceReasons: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(LiquidationDifferenceReason);
